import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwModalResult, ensureArray } from "@devwareapps/devware-cap";
import { AdminManagerService } from "../services/admin-manager.service";
import { Observable, of } from "rxjs";
import { FlightSchoolOrganizationEntity, UserTypeAllItems } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";

@DwAction({
    keyName: 'change-user-type',
    display: 'Change User Type',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    //parentItemName: [AppMetaDataItemNames.PlanOfAction],
    allowOnce: true,
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: '',
    }
})
@Injectable()
export class ChangeUserTypeActionService implements DwActionHandler {

    constructor(private adminManagerService: AdminManagerService) { }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const result = new DwActionResult();

        const data: FlightSchoolOrganizationEntity[] = ensureArray(actionState.data);

        if (data.length == 1 && data[0]?.FlightSchoolOrganizationId) {
            this.adminManagerService.updateAdminProperties({
                userTypeMode: UserTypeAllItems.FlightSchool,
                flightSchoolOrganizationId: data[0].FlightSchoolOrganizationId,
                flightSchoolId: data[0].FlightSchoolId
            });

            return of(result);
        }

        return this.adminManagerService.showUserTypeModal("Change User Type")
            .pipe(map((modalResult: DwModalResult) => {
                result.cancelled = modalResult.cancelled;
                result.success = !modalResult.cancelled;

                return result;
            }));
    }
}